import { KpiDefinition } from 'benchmarking-domain/kpi-definition';
import { NumberHelper } from 'helpers/number';

export const formatValueForChart = (
  value: number | null | undefined,
  kpi: KpiDefinition,
  roundPrecision: number = 4
) => {
  if (value == null) {
    return 'no value';
  }

  if (kpi.unit === '%') {
    return value?.toString() + '%';
  }

  return NumberHelper.formatNumber(value, roundPrecision);
};
